<template>
  <!-- eslint-disable -->
  <div>
    <auto-partes-add :is-add.sync="isAdd" ref="autoPartesAdd"> </auto-partes-add>
    <b-card no-body>
      <b-card-body>
        <b-row>
          <b-col md="2" class="mb-md-0 mb-2">
            <label>Categoría de Autoparte</label>
            <v-select
              v-model="selectedCategory"
              :options="categories"
              label="name"
              placeholder=""
              @input="filter"
            />
          </b-col>
          <b-col md="2" class="mb-md-0 mb-2">
            <label>Marca de Autoparte</label>
            <v-select
              v-model="selectedAutopartBrand"
              :options="autopartBrands"
              label="name"
              placeholder=""
              @input="filter"
            />
          </b-col>
          <!--<b-col md="2" class="mb-md-0 mb-2">
            <label>Marca de Vehículo</label>
            <v-select
              v-model="selectedCarBrand"
              :options="carBrands"
              label="name"
              placeholder=""
              @input="filter"
            />
          </b-col>
          <b-col md="2" class="mb-md-0 mb-2">
            <label>Modelo de vehículo</label>
            <v-select
              v-model="selectedModel"
              :options="models"
              label="name"
              placeholder=""
              @input="filter"
            />
          </b-col>-->
          <b-col md="4" class="mb-md-0 mb-2">
            <label>Descripción</label>
            <b-form-input v-model="description" placeholder="Descripción" @input="filter"/>
          </b-col>
          <b-col md="2" class="mb-md-0 mb-2">
            <label>Codigo</label>
            <b-form-input v-model="codigo" placeholder="Codigo" @input="filter"/>
          </b-col>
          <b-col md="2" class="mb-md-0 mb-2">
            <label>Codigo Alternativo</label>
            <b-form-input v-model="altercode" placeholder="Codigo Alterno" @input="filter"/>
          </b-col>

          <b-col md="2" class="mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="secondary"
              @click.prevent="clean"
            >
              <feather-icon icon="TrashIcon" class="mr-50" />
              <span class="align-middle">Limpiar</span>
            </b-button>
          </b-col>

          <b-col class="d-flex align-items-center justify-content-end mt-2">
          <b-button variant="primary" class="mr-2" @click="addAuto">
            <span class="text-nowrap">Agregar</span>
          </b-button>          
        </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
/* eslint-disable*/
import { BCard, BCardHeader, BCardBody, BRow, BCol, BButton, BFormGroup, BFormInput } from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import autoPartesAdd from './autoPartesAdd.vue'
import ReportService from '@/services/ReportsService'
import AutoPartsService from '@/services/AutoParts'
import VehicleService from '@/services/VehicleService'
export default {
  directives: {
    Ripple
  },
  data() {
    return {
      codigo: '',
      altercode: '',
      isAdd: false,
      selectedCategory: null, 
      selectedAutopartBrand: null,  
      selectedCarBrand: null, 
      selectedModel: null, 
      description: '',
      categories: [], 
      autopartBrands: [], 
      carBrands: [], 
      models: [], 
      arrayFilters: [],
    }
  },
  components: {
    BButton,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
    autoPartesAdd
  },
  mounted() {
    this.getExtraData()
  },
  methods: {
    async getExtraData() {
      const url = `?limit=200&page=1&order=asc&sort=id&filter=${JSON.stringify(this.arrayFilters)}`;
      const respBrand = await AutoPartsService.getAutoPartsBrand(url, this.$store);
      if (respBrand) {
        this.autopartBrands = respBrand.data.rows;
      }

      const respCategory = await AutoPartsService.getAutoPartsCategory(url, this.$store);
      if (respCategory) {
        this.categories = respCategory.data.rows;
      }

      const respVehicle = await VehicleService.getAutoPartsVehicle(url, this.$store);
      if (respVehicle) {
        this.carBrands = respVehicle.data.rows;
      }

      const respModel = await VehicleService.getModels(url, this.$store)
      if (respModel) {
        this.models = respModel.data.rows;
      }
    },
    addAuto() {
      this.isAdd = true
      this.$refs.autoPartesAdd.getData({})
    },
    async filter() {
      this.arrayFilters = [];

      if (this.selectedCategory) {
        this.arrayFilters.push({
          keyContains: 'autopartCategoryId',
          key: 'equals',
          value: this.selectedCategory.id
        });
      }

      if (this.selectedAutopartBrand) {
        this.arrayFilters.push({
          keyContains: 'autopartBrandId',
          key: 'equals',
          value: this.selectedAutopartBrand.id
        });
      }

      //if (this.selectedCarBrand) {
      //  this.arrayFilters.push({
      //    keyContains: 'carBrandId',
      //    key: 'equals',
      //    value: this.selectedCarBrand.id
      //  });
      //}

      //if (this.selectedModel) {
      //  this.arrayFilters.push({
      //    keyContains: 'autopartVehicleModels.some',
      //    key: 'carModelId',
      //    value: this.selectedModel.id
      //  });
      //}

      if (this.description.trim() !== '') {
        const palabras = this.description.trim().split(' ');
        palabras.forEach(palabra => {
          this.arrayFilters.push({
            keyContains: 'description',
            key: 'contains',
            value: palabra
          });
        });
      }

      if (this.codigo !== '') {
        this.arrayFilters.push({
          keyContains: 'originalCode',
          key: 'contains',
          value: this.codigo
        }); 
      }

      if (this.altercode !== '') {
        this.arrayFilters.push({
          keyContains: 'alterCode',
          key: 'contains',
          value: this.altercode
        }); 
      }

      this.$parent.$parent.arrayFilters = this.arrayFilters
      this.$parent.$parent.getData();
    },
    clean() {
      this.selectedCategory = null;
      this.codigo = '';
      this.description = '';
      this.altercode = '';
      this.selectedAutopartBrand = null;
      this.selectedCarBrand = null;
      this.selectedModel = null;
      this.arrayFilters = [];
      this.$parent.$parent.arrayFilters = this.arrayFilters
      this.$parent.$parent.getData();
    },
    async exportExcel() {
      let url = ''
      console.log('url', url)
      const respReport = await ReportService.reportAutoPartsExcel(url, this.$store)
      const url1 = window.URL.createObjectURL(respReport)
      const link = document.createElement('a')
      link.href = url1
      link.setAttribute('download', 'reporte.xlsx')
      document.body.appendChild(link)
      link.click()
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
